import { Event } from './event';

export class SubmitReviewTriggeredEvent extends Event<void> {}
